import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/shadcn/utils';

const paragraphVariants = cva('font-normal text-neutral-650', {
  variants: {
    variant: {
      body: 'text-sm leading-6',
      caption: 'text-xs leading-4 font-medium',
      tooltip: 'text-xs leading-5 text-white',
    },
    transform: {
      none: 'none',
      uppercase: 'uppercase',
    },
  },
  defaultVariants: {
    variant: 'body',
    transform: 'none',
  },
});

const Paragraph = ({
  className,
  variant,
  transform,
  ...props
}: React.ComponentProps<'p'> & VariantProps<typeof paragraphVariants>) => {
  return (
    <p
      className={cn(paragraphVariants({ variant, transform, className }))}
      {...props}
    />
  );
};

export { Paragraph };
